import request from "@/utils/http"
import store from "@/store"
import * as TemplateApi from "@/api/public/template"
import { getCachedObj, removeCache } from "@/utils/cache"
import { Message } from "element-ui"
import { cacheRequest } from "@/utils/decorator"

export function getSheetViews(sheetId, cache = true) {
  return viewApi.getSheetViews(sheetId, cache)
}

export function getOpenViews(sheetId) {
  return request.get(`/sheet/getViews/open/${sheetId}`).commonDeal()
}

export function getSheetView(viewId) {
  return request.get(`/sheet/getView/${viewId}`)
}

export function createSheetView(sheetView) {
  if (store.getters.isTemplateMode) {
    Message.warning("预览状态无法操作")
    return Promise.reject("预览状态无法操作")
  }
  return request.post("/sheet/createView", sheetView).commonDeal()
}

export function editSheetView(sheetView) {
  if (store.getters.isTemplateMode) {
    Message.warning("预览状态无法操作")
    return Promise.reject("预览状态无法操作")
  }
  return request.post("/sheet/editView", sheetView).commonDeal()
}

export function deleteSheetView(viewId) {
  return request.get(`/sheet/deleteView/${viewId}`)
}

export function getReports({
  viewId,
  dataIds = undefined, // undefined:全部
  conditions,
  gatherSetting = {}
}) {
  if (store.getters.isTemplateMode) {
    return Promise.resolve({ gatherRes: {} })
  }
  return request
    .post(`/sheet/getViewReport`, {
      viewId,
      dataIds,
      filtersList: conditions,
      gatherSetting
    })
    .commonDeal()
}

// 分类导航
export function getCategoryValueList({ viewId, conditions }, controlId) {
  return request
    .post(
      `/sheet/getCategoryValueList`,
      { viewId, filtersList: conditions },
      { params: { controlId } }
    )
    .commonDeal()
}

export function getSheetViewData({
  sheetId,
  viewId,
  dataIds = undefined, // undefined:全部
  page = 1,
  size = 100,
  conditions,
  // 用于关联字段筛选功能
  refSheetId = "",
  refControlId = "",
  refSheetData = null,
  // 按文本模糊搜索
  searchText,
  searchCids = undefined, // undefined:全部
  sorts = [],
  // 树状结构搜索
  rootId, // 树状展示时，根节点数据id
  treeKey, // 为树状展示，值是对应的关联字段。用viewId的时候可以不填
  refDataShowAsFirstField, // 关联多条是显示[x个]还是根据关联表的显示字段设置的第一个字段拼接
  realCount // 是否需要实际数据总数，false时返回数量最大为10000
}) {
  if (store.getters.isTemplateMode) {
    return TemplateApi.getSheetData({
      sheetId,
      viewId,
      dataIds,
      page,
      size,
      conditions,
      refSheetId,
      refControlId,
      refSheetData,
      searchText,
      searchCids,
      sorts,
      rootId,
      treeKey
    })
  }
  if (dataIds) {
    dataIds = dataIds.filter(id => id)
    if (!dataIds.length) {
      // 此情况下必然无结果,无需请求
      return Promise.resolve({ content: [], totalElements: 0 })
    }
  }
  return request
    .post(`/sheet/getSheetData`, {
      sheetId,
      viewId,
      dataIds,
      page,
      size,
      filtersList: conditions,
      refSheetId,
      refCid: refControlId,
      refSheetData,
      searchText,
      searchCids,
      sorts,
      rootId,
      treeKey,
      refDataShowAsFirstField,
      realCount
    })
    .commonDeal()
}

// 根据 Excel导出模板 导出 工作表数据
export function exportByExcelTemplate({ sheetId, viewId, filters = [], dataIds, templateId } = {}) {
  if (store.getters.isTemplateMode) {
    Message.warning("预览状态无法操作")
    return Promise.reject("预览状态无法操作")
  }
  return request
    .post(`/sheet/exportTpl`, { sheetId, viewId, filters, dataIds }, { params: { templateId } })
    .commonDeal()
}

export function getExcelImportTemplate(viewId) {
  if (store.getters.isTemplateMode) {
    Message.warning("预览状态无法操作")
    return Promise.reject("预览状态无法操作")
  }
  return request.post(`/sheet/getExcelImportTemplate`, null, {
    params: { viewId },
    responseType: "blob"
  })
}

export function createRefreshSheetDataTask(sheetId) {
  return request.post(`/sheet/createRefreshSheetDataTask`, null, {
    params: { sheetId }
  })
}

export function sortView(sheetId, viewIdList) {
  return request.post(`/sheet/sortView`, viewIdList, {
    params: { sheetId }
  })
}

class ViewApi {
  @cacheRequest()
  getSheetViews(sheetId, cache) {
    return store.getters.isTemplateMode
      ? TemplateApi.getAvailableViews(sheetId)
      : request.get(`/sheet/getViews/${sheetId}`).commonDeal()
  }
}
const viewApi = new ViewApi()
